module.exports = __webpack_public_path__ + "static/media/laddition-paiement-a-table.51b7bed3.png";